import { inject } from '@angular/core';

import { AuthService } from '@lib/auth';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';

import * as HmActions from './hm.actions';

export const setUserEffect = createEffect((actions$ = inject(Actions)): Observable<Action> => actions$.pipe(ofType(HmActions.setUser)), { functional: true, dispatch: false });

export const clearUserEffect = createEffect(
  (actions$ = inject(Actions), authService = inject(AuthService)): Observable<Action> =>
    actions$.pipe(
      ofType(HmActions.logoutUser),
      tap(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        authService.logout();
      })
    ),
  { functional: true, dispatch: false }
);
